import {
    Coroutine,
    CoroutineManager,
    waitForSeconds,
    wlUtils,
} from '@sorskoot/wonderland-components';
import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { DescriptionText } from '../ui/description.js';
import { Captions } from '../ui/captions.js';

export class TextsManager extends Component {
    static TypeName = 'texts-manager';

    @property.object({ required: true })
    uiTextObject!: Object3D;

    @property.object({ required: true })
    uiCaptionObject!: Object3D;

    // Singleton
    private static _instance: TextsManager;

    static get instance(): TextsManager {
        return TextsManager._instance;
    }

    private _coroutineManager: CoroutineManager = new CoroutineManager();
    private _descriptionTextComponent!: DescriptionText;
    private _captionTextComponent!: Captions;
    private _uiTextObjectTransform = new Float32Array(8);

    init() {
        if (TextsManager._instance) {
            console.error(
                'There can only be one instance of TextsManager Component'
            );
        }
        TextsManager._instance = this;
    }

    start() {
        wlUtils.setActive(this.uiTextObject, false);
        this._descriptionTextComponent =
            this.uiTextObject.getComponent(DescriptionText)!;
        this._descriptionTextComponent.description = '';

        //   wlUtils.setActive(this.uiCaptionObject, false);
        this._captionTextComponent =
            this.uiCaptionObject.getComponent(Captions)!;
        this._captionTextComponent.description = '';
    }

    update(dt: number) {
        this._coroutineManager.update(dt);
    }

    showText(text: string, object: Object3D) {
        this._descriptionTextComponent.description = text;

        object.getTransformWorld(this._uiTextObjectTransform);
        this.uiTextObject.setTransformWorld(this._uiTextObjectTransform);

        this._coroutineManager.stopCoroutine(this._showDescriptionId);
        this._showDescriptionId = this._coroutineManager.addCoroutine(
            new Coroutine(this._showDescription())
        );
    }

    showCaption(text: string) {
        this._captionTextComponent.description = text;

        this._coroutineManager.stopCoroutine(this._showCaptionId);
        this._showCaptionId = this._coroutineManager.addCoroutine(
            new Coroutine(this._showCaption())
        );
    }

    private _showDescriptionId: number = -1;
    private *_showDescription() {
        wlUtils.setActive(this.uiTextObject, true);
        yield* waitForSeconds(5);
        wlUtils.setActive(this.uiTextObject, false);
    }

    private _showCaptionId: number = -1;
    private *_showCaption() {
        wlUtils.setActive(this.uiCaptionObject, true);
        yield* waitForSeconds(5);
        wlUtils.setActive(this.uiCaptionObject, false);
    }
}
